// Square coverage quadrants around a hub, sized by radius km (T-GEO-001).
// The hub circle (radius = km) is inscribed in the full square. Corners map to
// the FMCG route quadrants. Polygons are [lat,lng] tuples (Leaflet-native).
export function squareQuadrants(hub, km) {
  const [cy, cx] = hub;
  const dLat = km / 111.32;
  const dLng = km / (111.32 * Math.cos((cy * Math.PI) / 180));
  const N = cy + dLat;
  const S = cy - dLat;
  const E = cx + dLng;
  const W = cx - dLng;
  return {
    NE: [[cy, cx], [N, cx], [N, E], [cy, E]],
    SE: [[cy, cx], [cy, E], [S, E], [S, cx]],
    SW: [[cy, cx], [S, cx], [S, W], [cy, W]],
    NW: [[cy, cx], [cy, W], [N, W], [N, cx]],
  };
}

export function polygonCentroid(poly) {
  let la = 0;
  let ln = 0;
  poly.forEach((p) => {
    la += p[0];
    ln += p[1];
  });
  return [la / poly.length, ln / poly.length];
}
